<template>
  <div class="about">
    <div class="right">
      <div class="resImg">
        <img :src="src.previewURL" alt="" />
      </div>
      <canvas ref="canvas"></canvas>
      <div class="rignt-btn">
        <div class="button-step">
          <div class="btn-text">
            <p>Upload your picture and</p>
            <p>turn it to a dotidoole</p>
            <p>puzzle package</p>
          </div>
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            v-model="ruleForm.coverFile"
          >
            <el-button slot="trigger" size="small" type="primary"
              >upload image</el-button
            >
          </el-upload>
        </div>
        <div class="btn-text">
          <p>Let our artist design it for you</p>
        </div>
        <el-button
          size="small"
          :disabled="btnChangeEnable"
          @click="toCart()"
          type="primary"
          >Add To Cart
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import VueDragResize from "vue-drag-resize";
export default {
  name: "About",
  components: {
    VueDragResize,
  },
  data() {
    return {
      ruleForm: {
        coverUrl: "",
        coverFile: "",
      },
      img1000: "",
      uplod: false,
      styleIndex: 0,
      BoxLeft: 0,
      BoxTop: 0,
      top: 0,
      parentW: 0,
      left: 0,
      value1: 0,
      height: "200",
      getWidth: 0,
      canvasHeight: "200",
      dragwidth: 16.22222,
      btnChangeEnable: true,
      src: {},
      onoff: true,
      Grayscaleoff: false,
      ele: null,
      interval: null,
    };
  },
  methods: {
    getparentW() {
      this.parentW =
        33.33333 * parseFloat(document.documentElement.style.fontSize);
    },
    beforeAvatarUpload(file) {
      this.getWidth =
        this.dragwidth * parseFloat(document.documentElement.style.fontSize);
      this.ruleForm.coverFile = file;
      this.imagePreview(this.ruleForm.coverFile);
      return false;
    },
    imagePreview: function (file) {
      var self = this;
      //定义一个文件阅读器
      var reader = new FileReader();
      //文件装载后将其显示在图片预览里
      reader.onload = function (e) {
        //将bade64位图片保存至数组里供上面图片显示
        self.ruleForm.coverUrl = e.target.result;
        self.initCanvas();
      };
      reader.readAsDataURL(file);
    },
    getW() {
      this.getWidth =
        this.dragwidth * parseFloat(document.documentElement.style.fontSize);
    },
    initCanvas() {
      var canvas = this.$refs.canvas;
      var ctx = canvas.getContext("2d");
      canvas.width = 1000;
      canvas.height = 1000;
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      var self = this;
      var img = new Image();
      img.src = self.ruleForm.coverUrl;
      img.onload = function () {
        var s = img.height / img.width;
        if (s > 1) {
          ctx.drawImage(img, 0, 0, (1000 / img.height) * img.width, 1000);
        } else if (s < 1) {
          ctx.drawImage(img, 0, 0, 1000, (1000 / img.width) * img.height);
        } else {
          ctx.drawImage(img, 0, 0, 1000, 1000);
        }
        // self.updata(canvas)
        self.img1000 = canvas.toDataURL("image/jpeg");
        self.updata();
      };
    },

    toCart() {
      window.location.href = `http://mskpt.com/cart/?add-to-cart=149&quantity=3&mproject_url=<img src="${this.src.thumbURL}"/>&mproject_info=${this.src.projectID}`;
    },
    updata: function () {
      if (!this.img1000) {
        return;
      }
      this.uplod = true;
      var img = this.img1000;
      var size = parseInt(img.length);
      let xm = `<?xml version="1.0" encoding="UTF-8"?>
                        <SOAP-ENV:Envelope
                            xmlns:SOAP-ENV="http://schemas.xmlsoap.org/soap/envelope/"
                            xmlns:xsd="http://www.w3.org/2001/XMLSchema"
                            xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
                            xmlns:SOAP-ENC="http://schemas.xmlsoap.org/soap/encoding/">
                            <SOAP-ENV:Body
                                xmlns:NS1="urn:ezm_renderIntf-Iezm_render"
                                SOAP-ENV:encodingStyle="http://schemas.xmlsoap.org/soap/encoding/">
                                <NS1:MRJpgUpload_HY2>
                                    <size xsi:type="xsd:int">
                                        ${size}
                                    </size>
                                    <jpg xsi:type="xsd:base64Binary">${img}</jpg></NS1:MRJpgUpload_HY2>
                            </SOAP-ENV:Body>
                        </SOAP-ENV:Envelope>`;
      this.$axios
        .post(
          "https://dotidoodle.com/render2/dotimap.dll/soap/Idotim_render",
          xm
        )
        .then((response) => {
          this.uplod = false;
          var parser = new DOMParser();
          var xmlDoc = parser.parseFromString(response.data, "text/xml");
          //获取DOM节点的标签为 dzLoginResult 的第一个节点对象
          var MDotResponse = xmlDoc.getElementsByTagName("NS2:TMRmsg")[0]
            .childNodes;
          MDotResponse.forEach((item) => {
            this.src[item.nodeName] = item.innerHTML;
          });
          // xmlDoc.getElementsByTagName('msg')[0];
          if (this.src.msg == "Good Request") {
            this.btnChangeEnable = false;
          }
        })
        .catch((error) => {
          self.uplod = false;
        });
    },
  },
};
</script>
<style lang="scss">
.vdr.active:before {
  content: "";
  outline: 4px dashed #d6d6d6 !important;
}
.el-radio__inner {
  width: 24px;
  height: 24px;
}
.el-radio__inner::after {
  width: 8px;
  height: 8px;
}
.el-radio__label {
  font-size: 18px;
}
.el-button {
  width: 256px;
  height: 60px;
  font-size: 30px;
  border-radius: 30px;
}
.s-list-tit {
  margin-bottom: 20px;
}
.box1 {
  width: 40%;
}
.list-top {
  margin-top: 40px;
}
.button-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 7rem;
  .button-step-text {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    font-size: 30px;
    align-items: center;
  }
  .btn {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    margin-right: 15px;
    font-size: 100px;
    text-align: center;
    line-height: 150px;
    font-weight: 600;
    color: white;
  }
  .btn1 {
    background: #d382af;
    margin-bottom: 50px;
  }
  .btn2 {
    background: #ab1b40;
  }
  .btn3 {
    margin-right: 0;
    margin-bottom: 50px;
    background: #662f8e;
  }
}
.about {
  border-radius: 20px;
  canvas {
    position: absolute;
    left: -10000px;
  }
  .right {
    padding: 30px 40px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 20px auto;
    background: #000;
    .resImg {
      margin-bottom: 10px;
      width: 500px;
      height: 500px;
      background: white;
      img {
        width: 100%;
      }
    }
    .rignt-btn {
      width: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .button-step {
        margin-bottom: 20px;
      }
      .btn-text {
        color: white;
        font-size: 24px;
        text-align: center;
        p {
          margin: 0;
          &.text-top {
            margin: 20px 0 10px;
          }
        }
      }
    }
  }
}
</style>